// @ts-nocheck
import YhcEFItemList from './components/YhcEFItemList/YhcEFItemList.vue'
import YhcEFPageHeader from './components/YhcEFPageHeader.vue'
import ZipCodeInput from './components/ZipCodeInput.vue'
import YhcEFSectionTitle from './components/YhcEFSectionTitle.vue'
import YhcEFKazaiSectionTitle from './components/YhcEFKazaiSectionTitle.vue'
import YhcEFDatetimeInputs from './components/YhcEFDatetimeInputs/YhcEFDatetimeInputs.vue'
import YhcEFPageFooter from './components/YhcEFPageFooter.vue'
import YhcEFTotalPriceDisplay from './components/YhcEFTotalPriceDisplay/YhcEFTotalPriceDisplay.vue'
import YhcPublicWebHtmlContentDisplay from './components/YhcPublicWebHtmlContentDisplay.vue'
import YhcEFKaguidoOption from './components/YhcEFKaguidoOption/YhcEFKaguidoOption.vue'

export const installYhcEstimateFormComponents = (Vue) => {
  Vue.component('YhcEFItemList', YhcEFItemList)
  Vue.component('YhcEFPageHeader', YhcEFPageHeader)
  Vue.component('ZipCodeInput', ZipCodeInput)
  Vue.component('YhcEFSectionTitle', YhcEFSectionTitle)
  Vue.component('YhcEFKazaiSectionTitle', YhcEFKazaiSectionTitle)
  Vue.component('YhcEFDatetimeInputs', YhcEFDatetimeInputs)
  Vue.component('YhcEFPageFooter', YhcEFPageFooter)
  Vue.component('YhcEFTotalPriceDisplay', YhcEFTotalPriceDisplay)
  Vue.component('YhcPublicWebHtmlContentDisplay', YhcPublicWebHtmlContentDisplay)
  Vue.component('YhcEFKaguidoOption', YhcEFKaguidoOption)
}
